export const routes = {
  FLEETS: '/fleets',
  TECHNICIANS: '/technicians',
  VEHICLES: '/vehicles',
};
